import { settings } from '../settings.js';

export const guides = {};

const getGuideDimensions = ({pattern, vertical, distance, rows, columns}) => {
    const yDist = pattern.rowDist();
    const xDist = pattern.colDist();

    const x = vertical ? (distance * xDist) + 79 : 79;
    const y = vertical ? 83 : (distance * yDist) + 83;
    const w = vertical ? 4 : columns * xDist;
    const h = vertical ? rows * yDist : 4;

    return {x, y, w, h};
};

class Guide {
    constructor ({distance, vertical, color}) {

        const {x, y, w, h} = getGuideDimensions({
            distance,
            vertical,
            pattern: settings.pattern,
            rows: settings.rows,
            columns: settings.columns
        });

        this.guide = game.add.rectangle(x, y, w, h, color)
            .setOrigin(0)
            .setDepth(0.1)
            .myIgnore('top');
    }

    destroy() {
        this.guide.destroy();
    }
}

guides.initialize = () => {
    guides.arr = [];
};

guides.newProject = () => {
    guides.destroyAll();
};

guides.destroyAll = () => {
    if (guides.arr) {
        guides.arr.forEach(guide => guide.destroy());
    }
    guides.arr = [];
};

guides.set = ({xSpacing, ySpacing, color=0x00ffff}) => {
    if (settings.pattern.noGuides) return;

    guides.destroyAll();

    for (let distance = 0; distance < settings.columns; distance += xSpacing) {
        guides.arr.push(new Guide({distance, vertical: true, color}));
    }

    for (let distance = 0; distance < settings.rows; distance += ySpacing) {
        guides.arr.push(new Guide({distance, vertical: false, color}));
    }
};